<template>
  <div
    class="btn-toolbar"
    role="toolbar"
    aria-label="Toolbar with button groups"
    style="position: relative; top:-1px; width: 230px!important; height: 10px!important; display: inline!important;"
  >
    <div
      class="btn-group btn-group-toggle btn-block ml-1 mr-1"
      role="group"
      style="width: 230px!important; height: 10px!important; display: inline!important;"
    >
      <button
        type="button"
        class="btn btn-candle"
        v-on:click="pickedTerm('short')"
        v-bind:class="[this.selectedTerm === 'short' ? 'active' : '']"
        style="padding: 0 5px 0 5px!important;"
      >
        {{ small ? "S" : "SHORT" }}
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-on:click="pickedTerm('medium')"
        v-bind:class="[this.selectedTerm === 'medium' ? 'active' : '']"
        style="padding: 0 5px 0 5px!important;"
      >
        {{ small ? "M" : "MEDIUM" }}
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-on:click="pickedTerm('long')"
        v-bind:class="[this.selectedTerm === 'long' ? 'active' : '']"
        style="padding: 0 5px 0 5px!important;"
      >
        {{ small ? "L" : "LONG" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermIntervals",
  props: {
    initTerm: { required: true },
    small: { required: true, type: Boolean, default: false }
  },
  data() {
    return {
      selectedTerm: "1Y"
    };
  },
  mounted() {
    this.selectedTerm = this.initTerm;
  },
  watch: {
    initTerm() {
      this.selectedTerm = this.initTerm;
    }
  },
  methods: {
    pickedTerm(interval) {
      this.selectedTerm = interval;
      this.$emit("eventOnChangeTerm", this.selectedTerm);
    }
  }
};
</script>
